import { getUserClaims } from "features/application/application-slice";
import { fetch_user_measurements } from "features/auto-thunks";
import { get_all_systemSetting } from "features/systemSetting/systemSetting-slice";
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";

export default function UserMeasurementsComponent() {
    const USER_MEASUREMENT = 'USER_MEASUREMENT';
    const claims = useSelector(getUserClaims);
    const dispatch = useDispatch();
    const systemSettings = useSelector(get_all_systemSetting);
    const userMeasurements = systemSettings.find(x => x.name === USER_MEASUREMENT);
    console.log(systemSettings)
    let userMeasurement = userMeasurements?.value ? JSON.parse(userMeasurements.value) : {};
    useEffect(() => {
        if (claims) {
            dispatch(fetch_user_measurements({
                playerId: claims.player
            }));
        }
    }, [claims]);

    if (!userMeasurement) {
        return <>
            <div>
                No measurements.
            </div>
        </>
    }
    const text_style = {
        fontSize: 20,
    }
    const h1_style = {
        display: 'inline-block',
        lineHeight: '1em'
    }
    return (
        <>
            <div>
                <div style={text_style}><h1 style={h1_style}>Total Users</h1>: {userMeasurement?.totalUsers}</div>
            </div>
            <div>
                <div style={text_style}><h1 style={h1_style}>Last Day</h1>: {userMeasurement?.signedIn?.lastDay}</div>
            </div>
            <div>
                <div style={text_style}><h1 style={h1_style}>Last 2 Days</h1>: {userMeasurement?.signedIn?.last2Days}</div>
            </div>
            <div>
                <div style={text_style}><h1 style={h1_style}>Last 7 Days</h1>: {userMeasurement?.signedIn?.lastWeek}</div>
            </div>
            <div>
                <div style={text_style}><h1 style={h1_style}>Last 30 Days</h1>: {userMeasurement?.signedIn?.thirtyDays}</div>
            </div>
            <div>
                <div style={text_style}><h1 style={h1_style}>Last 60 Days</h1>: {userMeasurement?.signedIn?.sixtyDays}</div>
            </div>
            <div>
                <div style={text_style}><h1 style={h1_style}>Last 180 Days</h1>: {userMeasurement?.signedIn?.days180}</div>
            </div>
            <div>
                <div style={text_style}><h1 style={h1_style}>Last 360 Days</h1>: {userMeasurement?.signedIn?.days360}</div>
            </div>
            <br />
        </>
    )
}